import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: (hasNotificationsEnabled: boolean | null | undefined) => string;
    error: (hasNotificationsEnabled: boolean | null | undefined) => string;
    notificationsAlreadyDisabled: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Toast message shown after toggling project notifications */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (hasNotificationsEnabled: boolean | null | undefined): string => { const notificationsEnabled = !!hasNotificationsEnabled; return __intl__.intl().formatMessage({ id: "useToggleProjectNotifications.title.0?c=389ikw349hkfl", defaultMessage: "{notificationsEnabled, select, true {Project notifications disabled. You''ll only be notified when @mentioned or assigned.} other {Project notifications enabled.}}" }, { notificationsEnabled: notificationsEnabled }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when project notification toggle fails */
            error: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (hasNotificationsEnabled: boolean | null | undefined): string => { const notificationsEnabled = !!hasNotificationsEnabled; return __intl__.intl().formatMessage({ id: "useToggleProjectNotifications.error.0?c=1a3eaydzsqba6", defaultMessage: "{notificationsEnabled, select, true {Project notifications can''t be disabled at this time.} other {Project notifications can''t be enabled at this time.}}" }, { notificationsEnabled: notificationsEnabled }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Message when attempting to disable already disabled notifications */
            notificationsAlreadyDisabled: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useToggleProjectNotifications.notificationsAlreadyDisabled?c=sb6wqry49ai3", defaultMessage: "Project notifications already disabled." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
